<template>
  <div class="formField">
    <div class="formField_cnt">
      <label class="formField_label" for="">
        <span>
          {{ label }}
          <span class="patternLabel" v-if="patternLabel">
            *{{ patternLabel }}
          </span>
        </span>
        <LabelRequire v-if="req" />
        <LabelOptional v-if="optional" />
      </label>
      <div class="formField_body">
        <slot></slot>
      </div>
    </div>
    <div class="formField_sub">
      <p class="description" v-if="description" v-html="description"></p>
      <Alert
        v-if="error"
        :text="errorMessage ? errorMessage : `${label}を入力してください`"
        inline
      />
    </div>
  </div>
</template>

<script lang="ts">
import Alert from '@/components/elements/Alert.vue'
import LabelRequire from '@/components/elements/LabelRequire.vue'
import LabelOptional from '@/components/elements/LabelOptional.vue'

export default {
  name: 'FormFieldset',

  components: {
    Alert,
    LabelRequire,
    LabelOptional
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    description: String,
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: String
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

//TODO: color指定のちほど整理

.formField {
  & + & {
    margin-top: 32px;
  }
}

.formField_cnt {
  @include mixins.media() {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.formField_label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  line-height: 1.4;

  @include mixins.media() {
    width: calc(37.5% - 20px);
    max-width: calc(37.5% - 20px);
    flex-basis: calc(37.5% - 20px);
    flex-shrink: 0;
    margin-bottom: 0;

    .formGroup & {
      padding-left: 20px;
    }
  }
}

.formField_body {
  position: relative;

  @include mixins.media() {
    width: calc(62.5% - 20px);
    max-width: calc(62.5% - 20px);
    flex-basis: calc(62.5% - 20px);
    flex-shrink: 0;
  }
}

.formField_sub {
  @include mixins.media() {
    margin-left: auto;
    width: calc(62.5% - 20px);
    max-width: calc(62.5% - 20px);
    flex-basis: calc(62.5% - 20px);
  }
}

.patternLabel {
  margin-left: 5px;
  font-size: 1rem;
  display: inline-block;
}

.description {
  margin-top: 10px;
  font-size: 1.2rem;
  color: #666;
}
</style>
